<script>
/*
const Vnos = {
  template: `<input @input="typing" ref="vnos-${entireQs.guid}" class="vnos vnos-${entireQs.guid}"></input>`
}
const vm = new Vnos({
  propsData: {
    text: 'HI :)'
  }
}).$mount('#mount');
*/
export default {
  methods: {
    renderInputs (question, entireQs) {
      // console.log('qs', entireQs.guid)
      // `<input @input="typing" ref="vnos-${entireQs.guid}" class="vnos vnos-${entireQs.guid}"></input>`
      // TODO: popravi če \begin{input}\end{input}, da zrenderira
      return question.split(/\\begin\s*{input}([\s\S]*?)\\end\s*{input}/g)
    }
  }
}
</script>

<style>
.vnos {
}
</style>



// WEBPACK FOOTER //
// AddInputs.vue?5f53ef92